<template>
    <div class="d-inline">
        <a class="text-body pe-2" style="cursor: pointer" title="ฉลากยา" v-on:click="getProductDosages()">
            <i class="fa fa-file-prescription"></i>
        </a>
        <div id="product-dosage-modal" class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">รายการสลากยา</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form id="save-form-dosage">
                            <div class="row mb-3">
                                <div class="col-md-12 mb-3">
                                    <div class="card border-0 bg-light">
                                        <div class="card-body p-3">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label class="d-flex align-items-center mb-0">
                                                        <input type="checkbox" class="me-2" id="showStoreInfo" 
                                                            name="show_store_info" checked v-model="show_store_info" value="true" />
                                                        <span>แสดงข้อมูลบริษัท</span>
                                                    </label>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label fw-semibold mb-2">
                                                        <i class="fa fa-language me-2 text-primary"></i>
                                                        เลือกภาษาที่ต้องการพิมพ์
                                                    </label>
                                                    <select class="form-select" v-model="selectedLanguage">
                                                        <option value="th">🇹🇭 ไทย (Thai)</option>
                                                        <option value="en">🇬🇧 อังกฤษ (English)</option>
                                                        <option value="zh">🇨🇳 จีน (Chinese)</option>
                                                        <option value="my">🇲🇲 พม่า (Myanmar)</option>
                                                        <option value="lo">🇱🇦 ลาว (Lao)</option>
                                                        <option value="km">🇰🇭 เขมร (Khmer)</option>
                                                    </select>
                                                    <small class="text-muted d-block mt-1">
                                                        <i class="fa fa-info-circle"></i>
                                                        หากไม่มีคำแปลจะแสดงภาษาไทยแทน
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3" style="overflow-y: scroll; max-height: 500px" id="collapse-container">
                                <template v-for="(item, i) in productDosages">
                                    <div class="col-12 border-bottom py-3" :key="item.id">
                                        <div class="d-flex justify-content-between align-content-center">
                                            <p class="m-0 align-self-center" data-bs-toggle="collapse"
                                                v-bind:href="`#collapse${i}`" role="button" aria-expanded="false">
                                                <i class="fa fa-angle-right text-muted"></i>
                                                {{ item.product_name }} [{{ item.amount }}
                                                {{ item.unit_name }}]
                                                <input type="hidden" name="product_id[]"
                                                    v-bind:value="item.product_id" />
                                                <input type="hidden" name="stock_transaction_id[]"
                                                    v-bind:value="item.stock_transaction_id" />
                                                <input type="hidden" name="amount[]" v-bind:value="item.amount" />
                                            </p>
                                            <div class="d-flex align-items-center"
                                                v-if="item.product_dosages.length > 0">
                                                <a style="cursor: pointer;" v-on:click="fetchData()">
                                                    <img width="25px" class="pe-2" src="/images/icon/rotate-solid.svg"
                                                        alt="">
                                                </a>
                                                <input class="me-3" type="checkbox" v-model="item.checked" />
                                                <template v-if="item.checked">
                                                    <select class="form-select" name="product_dosage[]"
                                                        v-model="item.dosage_selected_id" v-on:change="
                                                            setDosageLabel(i, item.dosage_selected_id)
                                                            ">
                                                        <template v-for="(
product_dosage, index
                              ) in item.product_dosages">
                                                            <option v-bind:value="product_dosage.id" :key="index">
                                                                {{ product_dosage.name }}
                                                            </option>
                                                        </template>
                                                    </select>
                                                </template>
                                            </div>
                                            <template v-else>
                                                <a v-bind:href="`${urlCreateProductDosages}?product_id=${item.product_id}`"
                                                    target="_blank">
                                                    เพิ่มข้อมูลสลาก
                                                </a>
                                            </template>
                                        </div>
                                        <div class="collapse text-start" v-bind:id="`collapse${i}`"
                                            data-bs-parent="#collapse-container">
                                            <span class="text-secondary fs-sm">ชื่อยา: {{ item.product_name }}</span>
                                            <span class="text-secondary fs-sm">จำนวน: {{ item.amount }}
                                                {{ item.dosage_selected.dosage_unit }}</span>
                                            <br />
                                            <span class="text-secondary fs-sm">รับประทานครั้งละ: {{
                                                item.dosage_selected.dosage }}
                                                {{ item.dosage_selected.dosage_unit }}</span>
                                            <br />
                                            <span class="text-secondary fs-sm">วันละ: {{ item.dosage_selected.daily }}
                                                ครั้ง</span>
                                            <br />
                                            <span class="text-secondary fs-sm">เวลาที่รับประทาน:
                                                {{ timeToEatText(item.dosage_selected) }}</span>
                                            <br />
                                            <span class="text-secondary fs-sm">หมายเหตุ: {{ item.dosage_selected.remark
                                            }}</span>
                                            <br>
                                            <div class="d-flex gap-2">
                                                <a v-if="item.dosage_selected?.id" class="btn btn-sm btn-alt-warning"
                                                    target="_blank"
                                                    :href="`/product-dosage/${item.dosage_selected.id}/edit`">แก้ไข</a>
                                                <a class="btn btn-sm btn-alt-primary" target="_blank"
                                                    :href="`${urlCreateProductDosages}?product_id=${item.product_id}`">
                                                    สร้างใหม่
                                                </a>
                                                <a v-if="item.dosage_selected?.id" class="btn btn-sm btn-alt-info"
                                                    target="_blank" v-on:click="copyDosage(item.dosage_selected?.id)">
                                                    คัดลอก
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                            ยกเลิก
                        </button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" v-on:click="print()">
                            ตกลง
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "get-cart-dosage",
    props: [
        "urlGetProductDosages",
        "urlPrintProductDosages",
        "urlCreateProductDosages",
        "cart",
        "customer",
    ],
    data() {
        return {
            productDosages: [],
            show_store_info: true,
            selectedLanguage: 'th'
        };
    },
    mounted() {
        console.log(this.urlCreateProductDosages);

    },
    methods: {
        copyDosage(id) {
            window.open(`${this.urlCreateProductDosages}?product_dosage_id=${id}`)
        },
        async getProductDosages() {
            let res = await axios.post(this.urlGetProductDosages, {
                orderDetails: this.cart,
            });

            this.productDosages = res.data.data;
            $("#product-dosage-modal").modal("show");
        },
        async fetchData() {
            let res = await axios.post(this.urlGetProductDosages, {
                orderDetails: this.cart,
            });
            this.productDosages = res.data.data;
        },
        async print() {
            let product_dosages = this.productDosages.map((item) => {
                return {
                    product_dosage_id: item.dosage_selected_id,
                    stock_transaction_id: item.stock_transaction_id,
                    amount: item.amount,
                    checked: item.checked,
                };
            });
            product_dosages = product_dosages.filter(
                (item) => item.product_dosage_id
            );
            product_dosages = product_dosages.filter((item) => item.checked);
            let res = await axios.post(this.urlPrintProductDosages, {
                product_dosages: product_dosages,
                customer: this.customer,
                show_store_info: this.show_store_info,
                locale: this.selectedLanguage
            });
            if (res.data.html) {
                let w = window.open(null, "print", "width=320,height=240");
                w.document.write(res.data.html);
                setTimeout(function () {
                    w.focus();
                    w.print();
                    w.close();
                }, 500);
            }
        },
        setDosageLabel(i, id) {
            let product_dosages = this.productDosages[i].product_dosages;
            let product_dosage = product_dosages.find((item) => item.id == id);
            this.productDosages[i].dosage_selected = product_dosage;
        },
        timeToEatText(dosageSelected) {
            let text = "";
            if (dosageSelected.morning) {
                text += "เช้า";
            }
            if (dosageSelected.noon) {
                text += " กลางวัน";
            }
            if (dosageSelected.evening) {
                text += " เย็น";
            }
            if (dosageSelected.before_bedtime) {
                text += " ก่อนนอน";
            }
            if (dosageSelected.have_symptom) {
                text += " เมื่อมีอาการ";
            }
            if (dosageSelected.every_hour) {
                text += ` ทุก ${dosageSelected.interval} ${dosageSelected.interval_unit}`;
            }
            return text;
        },
    },
};
</script>
<style scoped>
#collapse-container>div>div>p[aria-expanded="true"]>i {
    transform: rotate(90deg);
}

#collapse-container>div>div>.collapsed>i {
    transform: rotate(0deg);
}
</style>
